import React from "react";
import { useAppSelector } from "@/lib/redux/hooks";
import DesktopMenuComponent from "./DesktopMenu";
import DesktopNavComponent from "./DesktopNav";
import HomeLinkComponent from "./HomeLink";
import MenuButtonComponent from "./MenuButton";
import MobileMenuComponent from "./MobileMenu";
import { Container, Controls } from "./styles";
import { MainLayoutQuery } from "@/lib/sanity/queries";
import { LanguagePanel as LanguagePanelComponent } from "./LanguagePanel/LanguagePanel";
import WishlistButtonComponent from "./WishlistButton";

// Cast to fix React 17 + @types/react 18 compatibility issue
const HomeLink = HomeLinkComponent as any;
const LanguagePanel = LanguagePanelComponent as any;
const DesktopNav = DesktopNavComponent as any;
const DesktopMenu = DesktopMenuComponent as any;
const MobileMenu = MobileMenuComponent as any;
const MenuButton = MenuButtonComponent as any;
const WishlistButton = WishlistButtonComponent as any;

type Props = {
  navigation: MainLayoutQuery["header"]["navigation"];
};

const DefaultHeader: React.FC<Props> = (props) => {
  const { navigation } = props;
  const desktopMenuIsOpen = useAppSelector((state) => state.desktopMenu.isOpen);

  return (
    <>
      <Container $desktopMenuIsOpen={desktopMenuIsOpen}>
        <HomeLink />
        {navigation?.items && <DesktopNav items={navigation.items} />}
        <Controls>
          <LanguagePanel $desktopMenuIsOpen={desktopMenuIsOpen} />
          <WishlistButton />
          <MenuButton />
        </Controls>
      </Container>
      {navigation?.items && (
        <>
          <DesktopMenu items={navigation.items} />
          <MobileMenu items={navigation.items} />
        </>
      )}
    </>
  );
};

export default DefaultHeader;
